import { videoDataListsType } from "../shared/type";

export const videoDataLists: videoDataListsType[] = [
  {
    id: 1,
    title: "Glico Running Man",
    tags: ["Japan", "osaka", "glico", "signature spot", "shinsaibashi"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Glico%20Running%20Man.mp4",
  },
  {
    id: 2,
    title: "Japan ramen in street interview",
    tags: ["japan", "raman", "street view", "japan food", "interview"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Japan%20ramen%20in%20street%20interview.mp4",
  },
  {
    id: 3,
    title: "Japanese sushi",
    tags: ["japan", "sushi", "street view", "japan food", "interview"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Japanese%20sushi.mp4",
  },
  {
    id: 4,
    title: "Japanese-style Wagyu beef bowl",
    tags: ["japan", "japan food", "wagyu", "recommended", "hotel"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Japanese-style%20Wagyu%20beef%20bowl.mp4",
  },
  {
    id: 5,
    title: "salmon roe",
    tags: ["restaurant", "japan", "sushi", "japan food", "Sashimi"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/salmon%20roe.mp4",
  },
  {
    id: 6,
    title: "Self-service washing basins at Japanese temples",
    tags: [
      "japan temple",
      "japan culture",
      "japan travel",
      "luck",
      "japan manner",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Self-service%20washing%20basins%20at%20Japanese%20temples.mp4",
  },
  {
    id: 7,
    title: "Two-person boat on a Japanese lake",
    tags: [
      "japan view",
      "nature view",
      "lake boat",
      "Autumn foliage",
      "day trip",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Two-person%20boat%20on%20a%20Japanese%20lake.mp4",
  },
  {
    id: 8,
    title: "Yakiniku",

    tags: ["japan", "japan food", "wagyu", "Yakiniku", "restaurant"],

    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Yakiniku.mp4",
  },
  {
    id: 9,
    title: "Samgyeopsal",
    tags: [
      "korea food",
      "korea restaurant",
      "grilled meat",
      "Galbi",
      "Samgyeopsal",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Korea/Samgyeopsal.mp4",
  },
  {
    id: 10,
    title: "Pizza asia fav",
    tags: ["south east asia", "pizza", "food", "cheese", "restaurant"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/South%20East%20Asia/Pizza%20asia%20fav.mp4",
  },
  {
    id: 11,
    title: "scuba diving to explore coral reefs",
    tags: [
      "south east asia travel",
      "diving",
      "activities",
      "sea serving",
      "couple travel",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/South%20East%20Asia/scuba%20diving%20to%20explore%20coral%20reefs.mp4",
  },
  {
    id: 12,
    title: "Thai boat tour",
    tags: [
      "thai travel",
      "thai activities",
      "local tour",
      "sea market",
      "local culture",
      "thailand",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/South%20East%20Asia/Thai%20boat%20tour.mp4",
  },
  {
    id: 13,
    title: "Thai hot pot food",
    tags: [
      "thai food",
      "thai restaurant",
      "thai hot pot",
      "local food",
      "chill vibe",
      "thailand",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/South%20East%20Asia/Thai%20hot%20pot%20food.mp4",
  },
  {
    id: 14,
    title: "snorkeling",
    tags: ["snorkeling", "diving", "local tour", "activities", "sea"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Thai/snorkeling.mp4",
  },
  {
    id: 15,
    title: "Thai Skewers",
    tags: [
      "thai food",
      "thai restaurant",
      "skewers",
      "local food",
      "street food",
      "thailand",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Thai/Thai%20Skewers.mp4",
  },
  {
    id: 16,
    title: "Thai street food",
    tags: [
      "thai",
      "snack",
      "street view",
      "street food",
      "interview",
      "thailand",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Thai/Thai%20street%20food.mp4",
  },
  {
    id: 17,
    title: "Diving in Sanya",
    tags: [
      "china travel",
      "diving",
      "sanya",
      "travel activities",
      "local tour",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/China/Diving%20in%20Sanya.mp4",
  },
  {
    id: 18,
    title: "Landing to China",
    tags: ["china travel", "flight", "landing", "airport", "airplane"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/China/Landing%20to%20China.mp4",
  },
  {
    id: 19,
    title: "Road trip",
    tags: ["road trip", "china travel", "lhasa", "family trip", "couple trip"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/China/Road%20trip.mp4",
  },
  {
    id: 20,
    title:
      "I've been leaning towards more water in the matcha base and less milk when I want a strong latte.",
    tags: ["japan food", "matcha", "drinks", "local vibe", "chill"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/I%E2%80%99ve%20been%20leaning%20towards%20more%20water%20in%20the%20matcha%20base%20and%20less%20milk%20when%20I%20want%20a%20strong%20latte.mp4",
  },
  {
    id: 21,
    title: "Shibuya_Yakitori",
    tags: ["japan food", "yakitori", "japan local", "tokyo food", "shibuya"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Shibuya_Yakitori.mp4",
  },
  // {
  //   id: 22,
  //   title: "Suspension Bridge",
  //   tags: [
  //     "japan travel",
  //     "yakitori",
  //     "street view",
  //     "japan Bridge",
  //     "interview",
  //   ],
  //   videoUrl:
  //     "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/Suspension%20Bridge.mp4",
  // },
  {
    id: 23,
    title: "The clay pot rice",
    tags: ["japan", "japan food", "wagyu", "Yakiniku", "restaurant"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Japan/The%20clay%20pot%20rice.mp4",
  },
  {
    id: 24,
    title: "Seoraksan",
    tags: [
      "korea",
      "korea activities",
      "snow",
      "nature view",
      "outdoor activities",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Korea/Seoraksan.mp4",
  },
  {
    id: 25,
    title:
      "Oh god! Did you know that every single atom in your body was forged in the heart of a star?",
    tags: ["thai travel", "buji", "beach", "chill vibe", "nature"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/South%20East%20Asia/Oh%20god!%20Did%20you%20know%20that%20every%20single%20atom%20in%20your%20body%20was%20forged%20in%20the%20heart%20of%20a%20sta.mp4",
  },
  {
    id: 26,
    title: "This is simply wonderful",
    tags: ["south east asia", "life", "nature", "chill", "travel activities"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/South%20East%20Asia/This%20is%20simply%20wonderful.mp4",
  },
  {
    id: 27,
    title: "Grand Palace",
    tags: [
      "thai spot",
      "grand palace",
      "thai culture",
      "travel spot",
      "local tour",
      "thailand",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Thai/Grand%20Palace.mp4",
  },
  {
    id: 28,
    title: "Loy Krathong",
    tags: [
      "thai activities",
      "thai culture",
      "loy krathong",
      "festival",
      "local tour",
      "thailand",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Thai/Loy%20Krathong.mp4",
  },
  {
    id: 29,
    title: "Thai hotpot",
    tags: [
      "thai food",
      "thai restaurant",
      "thai hot pot",
      "local food",
      "chill vibe",
      "thailand",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Thai/Thai%20hotpot.mp4",
  },
  {
    id: 30,
    title: "Get surf",
    tags: ["singapore travel", "surf", "sea activities", "sport", "local tour"],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/singapore/get%20surf.mp4",
  },
  {
    id: 31,
    title: "Welcome to Being",
    tags: [
      "china travel",
      "beijing",
      "great wall",
      "The Forbidden City",
      "travel spot",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/China/Welcome%20to%20Being.mp4",
  },
  {
    id: 32,
    title: "Chicken makhni handi",
    tags: [
      "south east asia food",
      "makhni",
      "local food",
      "curry",
      "authentic",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/South%20East%20Asia/Chicken%20makhni%20handi.mp4",
  },
  {
    id: 33,
    title: "Dabajian_Taiwan",
    tags: [
      "Taiwan travel",
      "dabajian",
      "outdoor",
      "nature view",
      "mountain spot",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Taiwan/Dabajian_Taiwan.mp4",
  },
  {
    id: 34,
    title: "Yunsen Waterfall",
    tags: [
      "Taiwan travel",
      "yunsen waterfall",
      "nature spot",
      "outdoor",
      "public",
    ],
    videoUrl:
      "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Taiwan/Yunsen%20Waterfall.mp4",
  },
];
